import { QuestionBase } from "./question-base.model";

export class CountryMobNoQuestion extends QuestionBase<string> {
    controlType = 'countrymobno';
    type: string;
    maxlength: string;
    class_name: any;
    enablePlaceholder: boolean;
    phoneValidation: boolean;
    searchCountryFlag:boolean;
    parameter:string;
    preferredCountries:any;
    selectedCountryISO:string;
    separateDialCode:boolean;
    numberFormate:string;

   constructor(options: {} = {}) {
    super(options);
    this.type = options['type'] || '';
    this.maxlength = options['maxlength'] || '';
    this.class_name = options['class_name'] || '';
    this.parameter = options['CountryISO'] || '';
    this.numberFormate = options['numberFormate'] || '';
    this.preferredCountries = options['preferredCountries'] || 'in';
    this.selectedCountryISO = options['selectedCountryISO'] || 'in';
    this.separateDialCode = (options['separateDialCode'] == undefined) ? true : options['separateDialCode'];
    this.enablePlaceholder = (options['enablePlaceholder'] == undefined) ? true : options['enablePlaceholder'];
    this.phoneValidation = (options['phoneValidation'] == undefined) ? true : options['phoneValidation'];
    this.searchCountryFlag = (options['searchCountryFlag'] == undefined) ? true : options['searchCountryFlag'];
   }
}
